import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AlertTriangle, Home, BookOpen } from "lucide-react";

export default function GonePage() {
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center font-plex selection:bg-red-500/20 selection:text-white p-6 relative overflow-hidden">
      <Helmet>
        <title>410 Gone | Jamadhan</title>
        <meta name="description" content="This content has been permanently removed." />
      </Helmet>

      {/* GLOWS */}
      <div className="absolute top-[10%] left-1/4 w-[500px] h-[500px] bg-red-500/10 rounded-full blur-[150px] pointer-events-none z-0" />
      
      <div className="relative z-10 text-center max-w-2xl mx-auto">
        <h1 className="text-[120px] md:text-[180px] font-black font-outfit text-white/5 leading-none select-none drop-shadow-2xl">
          410
        </h1>
        <div className="-mt-16 md:-mt-24 mb-8">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-red-500/20">
            <AlertTriangle className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white font-outfit mb-4">
            Permanently Deleted
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-md mx-auto">
            The content you are looking for has been permanently removed from Jamadhan and is no longer available.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
          <Link to="/" className="group flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 rounded-xl p-4 transition-all duration-300">
            <Home className="w-5 h-5 text-white/70 group-hover:scale-110 transition-transform" />
            <span className="text-white font-medium">Back to Home</span>
          </Link>
          <Link to="/courses" className="group flex items-center justify-center gap-2 bg-[#00FF88]/10 hover:bg-[#00FF88]/20 border border-[#00FF88]/20 hover:border-[#00FF88]/50 rounded-xl p-4 transition-all duration-300">
            <BookOpen className="w-5 h-5 text-[#00FF88] group-hover:scale-110 transition-transform" />
            <span className="text-white font-medium">Browse New Courses</span>
          </Link>
        </div>
      </div>
      
      {/* BACKGROUND GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none opacity-50 z-0" />
    </div>
  );
}
